import { useContext } from 'react';
import { TouchableOpacity } from 'react-native';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { MBIconV2 } from '@shared/components/image';
import { ColorThemeContext, grid } from '@shared/styles';
import { API } from '@shared/types/api';
import { getTestId } from '@shared/util/getTestId';
import { useIsDesktop } from '@shared/util/hooks';
import { i18n } from '@shared/util/i18n';

interface AddMoreButtonProps {
  onPress: VoidFunction;
  component: API.AnyComponent;
  label?: string;
}

export function AddMoreButton({
  onPress,
  component,
  label = i18n('card.blocks.cardsInput.addMore'),
}: AddMoreButtonProps) {
  const isDesktop = useIsDesktop();
  const colors = useContext(ColorThemeContext);

  return (
    <TouchableOpacity
      onPress={onPress}
      style={{
        paddingVertical: grid(1),
        paddingRight: grid(1),
        marginLeft: -grid(0.75),
        flex: isDesktop ? undefined : 1,
      }}
      testID={getTestId('add-more-button', component.id)}
    >
      <View row centerVertically style={{ height: grid(2.5) }}>
        <MBIconV2
          name="plus-circle"
          size={grid(3.5)}
          color={colors.foregroundActive}
          style={{ marginRight: grid(0.25) }}
        />
        <Text size="body2">{label}</Text>
      </View>
    </TouchableOpacity>
  );
}
